import React from "react";
import { Form, Radio } from "antd";

import "./index.css";

const RadioGroupItem = ({
  label,
  button,
  labels,
  message,
  optional,
  onChange,
  vertical,
  labelCol,
  disabled,
  className,
  fieldName,
  wrapperCol,
  initialValue,
  formItemLayout,
  secondDisabled,
  getFieldDecorator,
}) => (
  <Form.Item
    label={label}
    className={className}
    labelCol={labelCol ? { span: labelCol } : formItemLayout.labelCol}
    wrapperCol={wrapperCol ? { span: wrapperCol } : formItemLayout.wrapperCol}
  >
    {getFieldDecorator(fieldName, {
      initialValue: initialValue,
      rules: [
        {
          required: message && !optional,
          message,
        },
      ],
    })(
      <Radio.Group onChange={onChange}>
        {labels.map((l, i) =>
          button ? (
            <Radio.Button
              key={i}
              value={i + 1}
              id={l.toString()}
              disabled={disabled || (i === 1 && secondDisabled)}
            >
              {l}
            </Radio.Button>
          ) : (
            <Radio
              key={i}
              value={i + 1}
              id={l.toString()}
              className={vertical && "vertical-radio-group"}
              disabled={disabled || (i === 1 && secondDisabled)}
            >
              {l}
            </Radio>
          )
        )}
      </Radio.Group>
    )}
  </Form.Item>
);

export default RadioGroupItem;
